import * as React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import List from "./Ops.Merchants.List";
import TagCloud from "./Ops.Merchants.TagCloud";
import Payments from "./Ops.Merchants.Payments";
import Snapcode from "./Ops.Merchants.Snapcode";
import CashbackStrategy from "./Ops.Merchants.CashbackStrategy";
import Tags from "./Ops.Merchants.Tags";
import Rates from "./Ops.Merchants.Rates";

const Merchants = (props) => (
  <Switch>
    <Route
      exact={true}
      path="/snapscan/ops/merchants"
      render={() => <Redirect to="/snapscan/ops/merchants/list" />}
    />
    <Route
      exact={true}
      path="/snapscan/ops/merchants/list"
      render={(routerProps) => <List {...{ ...props, ...routerProps }} />}
    />
    <Route
      exact={true}
      path="/snapscan/ops/merchants/tag_cloud"
      render={() => <TagCloud {...props} />}
    />
    <Route
      exact={true}
      path="/snapscan/ops/merchants/:id/snapcode"
      render={(routerProps) => <Snapcode {...{ ...props, ...routerProps }} />}
    />
    <Route
      exact={true}
      path="/snapscan/ops/merchants/:id/payments"
      render={(routerProps) => <Payments {...{ ...props, ...routerProps }} />}
    />
    <Route
      exact={true}
      path="/snapscan/ops/merchants/:id/rates"
      render={(routerProps) => <Rates {...{ ...props, ...routerProps }} />}
    />
    <Route
      exact={true}
      path="/snapscan/ops/merchants/:id/cashback"
      render={(routerProps) => (
        <CashbackStrategy {...{ ...props, ...routerProps }} />
      )}
    />
    <Route
      exact={true}
      path="/snapscan/ops/merchants/:id/tags"
      render={(routerProps) => <Tags {...{ ...props, ...routerProps }} />}
    />
  </Switch>
);

export default Merchants;
